import { HttpClient } from '@angular/common/http';
import { Base } from '../../base';
import { Funds } from './pools/funds';

export class Pools extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/pools`);
  }

  of(id: string) {
    id = id.toLowerCase();
    return {
      funds: new Funds(this.httpClient, this.pathJoin(id))
    };
  }
}
